<template>
  <div :class="{'modal': true, 'is-active': alert_modal_flag}">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title" v-text="'Update Ticket'"></p>
        <button class="delete" aria-label="close"></button>
      </header>
      <section class="modal-card-body">
        <div class="field">
          <div class="control">
            <money :class="{'input': true}" v-model="tickets" v-bind="number_format"></money>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <button class="button is-success" v-text="'Update'" @click="closeModal('update')"></button>
        <button class="button is-danger" v-text="'Cancel'" @click="closeModal('cancel')"></button>
      </footer>
    </div>
  </div>
</template>

<script>
import {Money} from 'v-money'
export default {
  data () {
    return {
      alert_modal_flag: false,
      tickets: 0,
      index_parent: '',
      index_counter_event: '',
      number_format: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: false
      },
      event_bus_alert_modal: ''
    }
  },
  components: {
    Money
  },
  props: [
    'updateTicketsModalFlag',
    'propsTickets',
    'indexParent',
    'indexCounterEvent'
  ],
  watch: {
    updateTicketsModalFlag (value) {
      this.alert_modal_flag = value
    },
    propsTickets (value) {
      this.tickets = value
    },
    indexParent (value) {
      this.index_parent = value
    },
    indexCounterEvent (value) {
      this.index_counter_event = value
    }
  },
  methods: {
    closeModal (flag) {
      this.alert_modal_flag = false
      this.$geb.emit({id: 'modify-tickets', action: flag, tickets: this.tickets, index_parent: this.index_parent, index_counter_event: this.index_counter_event})
      this.tickets = 0
      this.index_parent = ''
      this.index_counter_event = ''
    }
  },
  beforeDestroy () {
    if (this.event_bus_alert_modal) {
      this.event_bus_alert_modal.unsubscribe()
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/pages/panel/task/components/UpdateTicketsModal.vue